// import clone from 'clone'
// import { initialState } from '../index'
import { BATCHGLUPDATE_INIT_LOADING, BATCHGLUPDATE_INIT_SUCCESS, BATCHGLUPDATE_INIT_FAIL } from '@/store/types'

export const init = {
  [BATCHGLUPDATE_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [BATCHGLUPDATE_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [BATCHGLUPDATE_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  }
}
